import styled from "styled-components";

export const SharedContactView = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxx_small }px;

  & > div.contact-card {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
    padding: ${({ theme }) => theme.spacing.x_small }px;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    background-color: ${({ theme }) => theme.colors.text.default }11;
    color: ${({ theme }) => theme.colors.text.default };
    text-align: left;
  }

  & div.contact-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
  }

  & div.contact-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.text.default }22;
    color: ${({ theme }) => theme.colors.text.default };
  }

  & div.contact-info {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    overflow: hidden;
  }

  & div.contact-info > strong,
  & div.contact-info > span,
  & span.more-contacts {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & div.contact-info > strong {
    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-weight: 600;
  }

  & div.contact-info > span,
  & span.more-contacts {
    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    color: ${({ theme }) => theme.colors.text.default }CC;
  }

  & div.contact-actions {
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
    margin-top: ${({ theme }) => theme.spacing.xx_small }px;
  }

  & div.contact-actions > button {
    padding: ${({ theme }) => theme.spacing.xx_small }px ${({ theme }) => theme.spacing.x_small }px;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    border: none;
    background-color: ${({ theme }) => theme.colors.text.default }22;
    color: ${({ theme }) => theme.colors.text.default };
    cursor: pointer;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    transition: all .2s;
  }

  & div.contact-actions > button:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.text.default }33;
  }

  & div.contact-actions > button:disabled {
    cursor: not-allowed;
    opacity: .5;
  }
`;
